import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch("https://admin.leapatinternational.com/category_api.php") // Replace with your actual API URL
      .then((response) => response.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);
  return (
    <>
      {/* Top Bar Start */}
      <header class="header">
        <div class="container-fluid container">
            <div class="d-flex align-items-center justify-content-between main_header">
                
               
                <div class="logo">
                <a href="/">
                    <img src="/assets/img/Leapat_header_logo.png" alt="Logo"/>
                    </a>
                </div>
    
               
                <nav class="navbar navbar-expand-lg desktop-nav">
                    <ul class="navbar-nav mx-auto">
                        <li class="nav-item">
                            <Link to="/" className="nav-link text-white">Home</Link>
                        </li>
                        <li class="nav-item dropdown">
                            <a href="#" className="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">Collection</a>
                            <ul class="dropdown-menu">
                                {categories.map((category) => (
                                    <Link key={category.id} to={`/category/${category.id}`} class="dropdown-item">
                                      {category.title}
                                    </Link>
                                  ))}
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown">Resource</a>
                            <ul class="dropdown-menu">
                                <Link to="/warranty" className="dropdown-item">Warranty</Link>
                                <Link to="/installation-guide" className="dropdown-item">Installation Guide</Link>
                                <Link to="/product-specs" className="dropdown-item">Product Specification</Link>
                               
                            </ul>
                        </li>
                        <li class="nav-item">
                            <Link to="/contact" className="nav-link text-white">Contact Us</Link>
                            
                        </li>
                    </ul>
                </nav>
    
               
                <div class="d-none d-lg-flex align-items-center">
                    <div class="help-section">
                        <div class="call-icon">
                            <img src="/assets/img/chat_phone.png" alt="Call" width="50"/>
                        </div>
                        <div>
                            <small>Need help?</small><br/>
                            <strong class="contact_num">+1-401-660-3457</strong>
                        </div>
                        <button class="quote-btn desktop-quote">QUOTE</button>
                    </div>
                   
                </div>
    
               
                <button class="btn btn-outline-light d-lg-none" data-bs-toggle="offcanvas" data-bs-target="#mobileDrawer">
                    ☰ Menu
                </button>
    
            </div>
        </div>
    </header>
    
    <div class="offcanvas offcanvas-end" tabindex="-1" id="mobileDrawer">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title">Menu</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div class="offcanvas-body">
            
            <ul class="navbar-nav">
                <li class="nav-item">
                    <Link to="/" className="nav-link text-white">Home</Link>
                </li>

             
                <li class="nav-item dropdown">
                    <a href="#" className="nav-link dropdown-toggle text-white" data-bs-toggle="dropdown">Collection</a>
                    <ul class="dropdown-menu">
                        {categories.map((category) => (
                            <Link key={category.id} to={`/category/${category.id}`} class="dropdown-item">
                              {category.title}
                            </Link>
                          ))}
                    </ul>
                </li>
                <li class="nav-item dropdown">

                    <a class="nav-link dropdown-toggle text-white" href="#" role="button" data-bs-toggle="dropdown">Resource</a>
                    <ul class="dropdown-menu">
                        <Link to="/warranty" className="dropdown-item">Warranty</Link>
                        <Link to="/installation-guide" className="dropdown-item">Installation Guide</Link>
                        <Link to="/product-specs" className="dropdown-item">Product Specification</Link>
                       
                    </ul>

                  
                </li>
                
                <li class="nav-item">
                    <Link to="/contact" className="nav-link text-white">Contact Us</Link>
                    
                </li>
            </ul>
    
            <hr/>
    
           
            <div class="help-section d-flex align-items-center">
                <div class="call-icon">
                    <img src="/assets/img/chat_phone.png" alt="Call" width="50"/>
                </div>
                <div>
                    <small>Need help?</small><br/>
                    <strong>+1-401-660-3457</strong>
                </div>
            </div>
            <button class="quote-btn mt-3 w-100">QUOTE</button>
        </div>
    </div>






     
    </>
  );
};

export default Header;
